module.exports = "<div class=\"widget-box\">\n\t<ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/widget/widget.html
// module id = 547
// module chunks = 0